import { useContext } from 'react'
import { Context } from '../contexts/Web3Context'

function useWeb3 () {
  const { web3 } = useContext(Context)
  return web3
}

export default useWeb3
